import React, { createContext, useContext, useState, useEffect } from "react";
import { getAllSectionBrands } from "../services/brandService";
import { useAuth } from "./AuthContext";

const BrandsContext = createContext();

export const useBrands = () => useContext(BrandsContext);

export const BrandsProvider = ({ children }) => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);

  const { token } = useAuth();

  const fetchBrands = async () => {
    try {
      setLoading(true);

      const response = await getAllSectionBrands();

      setBrands(response.data);
    } catch (err) {
      console.error("Failed to fetch brands", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchBrands();
    } else {
      setBrands([]);
    }
  }, [token]);

  // Optional: manual refresh
  const refreshBrands = () => fetchBrands();

  return (
    <BrandsContext.Provider value={{ brands, loading, refreshBrands }}>
      {children}
    </BrandsContext.Provider>
  );
};
